import keyMirror from 'keymirror-nested'

export default keyMirror({
  MCLEOD_COMPANIES: {
    FETCH: {
      REQUEST: null,
      SUCCEEDED: null,
      FAILED: null,
    },
    CLEAN: {
      ERRORS: null,
      STATE: null,
    },
  },
})
